export default __webpack_public_path__ + "static/media/image2-mobile.91ddf005.png";